import React from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import ListDataKumpulanDataOpenData from "./kumpulan_data/ListDataKumpulanDataOpenData";

const PagesKumpulanDataOpenData = ({formatDate})=>{
    
    return(
        <div>
            <HeaderOpenData />
            <ListDataKumpulanDataOpenData formatDate={formatDate} />
            <FooterOpenData />
        </div>
    )
}

export default PagesKumpulanDataOpenData;